<div class="dialogContainer">
  <div class="content">
    <div class="panel">
      <div class="addressDetail">
        <div class="headerLabel">Entered Address</div>
        <div class="displayRow">
          <span class="valueLabel">Address Line 1:</span>
          <span class="valueField">{{ enteredAddress.addressLine1 }}</span>
        </div>
        <div class="displayRow">
          <span class="valueLabel">Address Line 2:</span>
          <span class="valueField">{{ enteredAddress.addressLine2 }}</span>
        </div>
        <div class="displayRow">
          <span class="valueLabel">City:</span>
          <span class="valueField">{{ enteredAddress.cityName }}</span>
        </div>
        <div class="displayRow">
          <span class="valueLabel">Region:</span>
          <span class="valueField">{{ enteredAddress.stateCode }}</span>
        </div>
        <div class="displayRow">
          <span class="valueLabel">Postal Code:</span>
          <span class="valueField">{{ enteredAddress.postalCode }}</span>
        </div>
        <div class="displayRow">
          <span class="valueLabel">Country:</span>
          <span class="valueField">{{ enteredAddress.countryCode }}</span>
        </div>
        <div class="buttonRow">
          <span class="spacer"></span>
          <button class="warn-button" matButton="elevated" (click)="close()">{{ getCloseButtonText() }}</button>
        </div>
      </div>
    </div>
    <div class="panel">
      @if (validatedAddress) {
        <div class="addressDetail">
          <div class="headerLabel">Suggested Address</div>
          <div class="displayRow">
            <span class="valueLabel">Address Line 1:</span>
            <span class="valueField">{{ validatedAddress.line1 }}</span>
          </div>
          <div class="displayRow">
            <span class="valueLabel">Address Line 2:</span>
            <span class="valueField">{{ validatedAddress.line2 }}</span>
          </div>
          <div class="displayRow">
            <span class="valueLabel">City:</span>
            <span class="valueField">{{ validatedAddress.city }}</span>
          </div>
          <div class="displayRow">
            <span class="valueLabel">Region:</span>
            <span class="valueField">{{ validatedAddress.region }}</span>
          </div>
          <div class="displayRow">
            <span class="valueLabel">Postal Code:</span>
            <span class="valueField">{{ validatedAddress.postalCode }}</span>
          </div>
          <div class="displayRow">
            <span class="valueLabel">Country:</span>
            <span class="valueField">{{ validatedAddress.country }}</span>
          </div>
          <div class="buttonRow">
            <span class="spacer"></span>
            <button class="primary-button" matButton="elevated" (click)="useValidatedAddress()">Use Suggested Address</button>
          </div>
        </div>
      }
      @if (noSuggestionMessage) {
        <div class="addressDetail">
          <span class="noSuggestionMessage">
            {{ noSuggestionMessage }}
          </span>
        </div>
      }
    </div>
    @if (addressValidationErrors) {
      <div class="validationErrors">
        <span class="addressMessages">
          {{ addressValidationErrors }}
        </span>
      </div>
    }
  </div>
</div>
